export class UniqueHtmlElement<TElement extends HTMLElement> {
  protected element: TElement | null;

  constructor(selector: string) {
    this.element = document.querySelector<TElement>(selector);

    if (!this.element) {
      throw new Error(`unable to find element with selector: '${selector}'`);
    }
  }

  hide() {
    return UniqueHtmlElement.hide(this.element);
  }

  show() {
    return UniqueHtmlElement.show(this.element);
  }

  static hide(element?: HTMLElement | SVGElement | null) {
    element?.classList.add('fade');
    element?.classList.remove('show');

    return new Promise<void>(resolve =>
      setTimeout(() => {
        element?.classList.add('d-none');
        resolve();
      }, 150),
    );
  }

  static show(element?: HTMLElement | SVGElement | null) {
    element?.classList.remove('d-none');
    element?.classList.add('fade');
    element?.classList.add('show');

    return new Promise<void>(resolve => setTimeout(() => resolve(), 150));
  }
}
